import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { HtmlRenderer } from '../../../components/htmlAreas/htmlRenderer';
import { MarkdownRenderer } from '../../../components/markdownRenderer';
import { PanelItemDivider } from '../../../panels/panelItemDivider';
import { useAppSelector } from '../../../redux/store';
import { MTT_STAGING_MAIN_PANEL_BACKGROUND_COLOR } from '../../../styles/colors';
import { MttStagingSubSection } from './mttStagingSubSection';
const CONTAINER_CSS = css `
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 5px;
`;
export const MttStagingInfoDisplay = () => {
    const gameName = useAppSelector((state) => state.mttStaging.gameName || 'Tourney Info');
    const mttSettingsHtml = useAppSelector((state) => state.mttStaging.mttSettingsHtml);
    const infoMarkdown = useAppSelector((state) => state.mttStaging.infoMarkdown);
    return (_jsx(MttStagingSubSection, { title: gameName, bgColor: MTT_STAGING_MAIN_PANEL_BACKGROUND_COLOR, children: _jsxs("div", { css: CONTAINER_CSS, children: [infoMarkdown ? (_jsxs(_Fragment, { children: [_jsx("section", { "aria-label": 'tournament description', children: _jsx(MarkdownRenderer, { markdown: infoMarkdown }) }), _jsx(PanelItemDivider, { color: 'black', thicknessPx: 2 })] })) : null, _jsx("section", { "aria-label": 'tournament info', children: _jsx(HtmlRenderer, { html: mttSettingsHtml }) })] }) }));
};
